module.exports = __webpack_public_path__ + "static/media/120-bahamas.1b252b60.svg";